<template>
  <b-card class="card-custom m-5">
    <!--begin::Header-->
    <div class="d-flex justify-content-between mb-5">
      <b-card-title class="card-title">
        <h3 class="card-label font-weight-bolder text-dark">Verify Employee</h3>
      </b-card-title>
      <b-button
        class="btn btn-sm btn-icon btn-light-secondary btn-hover-danger"
        v-on:click="goBack"
        ><i class="ki ki-close icon-xs"></i
      ></b-button>
    </div>
    <!--end::Header-->
    <!--begin::Check-->

    <AppLoader v-if="isBusy"></AppLoader>

    <!-- begin::: Confirm Account -->
    <div class="d-flex flex-column flex-lg-column">
      <inline-svg
        class="
          w-lg-200px w-md-200px w-sm-100px w-200px
          h-200px
          align-self-center
        "
        src="/media/svg/illustrations/others/undraw_astronaut.svg"
      />

      <div class="d-flex px-2 ml-lg-5 flex-column" v-if="!isBusy">
        <h4 class="mb-5">Do you have a <strong>SmartId</strong> Account?</h4>
        <b-button
          variant="primary"
          size="lg"
          class="font-weight-bold font-size-h5 mt-5"
          v-on:click="existingAccountClick"
          >Yes, I have
        </b-button>
        <b-button
          variant="light"
          size="lg"
          class="font-size-h5 font-weight-bold mt-5"
          v-on:click="nonAccountClick"
          >No, I do not
        </b-button>
      </div>
    </div>
    <!-- end::: Confirm Account -->

    <!--end::check-->
  </b-card>
</template>

<script>
import { mapState } from "vuex";
import AppLoader from "@/modules/core/components/loaders/AppLoader";

export default {
  name: "EmployeeVerificationAccountCheck",
  components: { AppLoader },
  methods: {
    nonAccountClick() {
      console.log("This employee does not have account yet.");
      this.$router.push({
        path: "employee/register",
        query: { code: this.code },
      });
    },
    existingAccountClick() {
      console.log("This employee might have an account.");
      this.$router.push({ path: "employee/login", query: { code: this.code } });
    },
    goBack() {
      console.log("");
      this.$router.push("/login");
    },
  },
  computed: {
    ...mapState({
      code: (state) =>
        state.AuthModule.EmployeeVerification.VerificationInit.verificationCode,
      isBusy: (state) =>
        state.AuthModule.EmployeeVerification.VerificationInit.busy,
    }),
  },
};
</script>

<style scoped></style>
